// eslint-disable-next-line import/prefer-default-export
export const kycReducer = (state, action) => {
  const { type, payload } = action;
  if (type === 'GET_USER_KYCS') {
    return { state, kycs: payload };
  }
  return state;
};
